import axios from "axios";

export default {

    namespaced: true,

    state: {
        account: {},
        accounts: [],
        detailTypes: [],
        parentAccounts: [],
        allpostingAccounts: []
    },

    getters: {
        accounts(state) {
            return state.accounts;
        },
        account(state) {
            return state.account;
        },
        detailTypes(state) {
            return state.detailTypes;
        },

        incomeAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "1100" && e.prevent_manual_posting == false);
        },

        capitalAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "1400" && e.prevent_manual_posting == false);
        },

        bankingAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "200" && e.prevent_manual_posting == false);
        },

        nonBankingAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type != "300" && e.detail_type != "200" &&  e.detail_type != "700" && e.prevent_manual_posting == false);
        },

        postingAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.prevent_manual_posting == false);
        },

        accountsReceivable(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "300" && e.prevent_manual_posting == false);
        },

        currentLiabilities(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "800" && e.prevent_manual_posting == false);
        },

        expenseAccounts(state) {
            return state.allpostingAccounts?.filter(e => e.detail_type == "1200" && e.prevent_manual_posting == false);
        },

       
        allpostingAccounts(state) {
            return state.allpostingAccounts;
        },
        groupingAccounts(state) {
            return state.groupingAccounts;
        },
      
      

       
    },

    mutations: {
        FETCH_ACCOUNTS(state, data) {
            state.accounts = data;
        },
        FETCH_DETAIL_TYPES(state, data) {
            state.detailTypes = data;
        },
        FETCH_GROUPING_ACCOUNTS(state, data) {
            state.groupingAccounts = data;
        },

        FETCH_ALL_POSTING_ACCOUNTS(state, data) {
            state.allpostingAccounts = data;
        },

    },

    actions: {
        fetchAccounts({ commit }, params) {
            axios.get('/api/v1/accounts', { params: params })
                .then(res => {
                    commit('FETCH_ACCOUNTS', res.data.data);
                }).catch(err => {
                    return Promise.reject(err);
                })
        },
        fetchDetailTypes({ commit }, params) {
            axios.get('/api/v1/accounts/getDetailTypes', { params: params })
                .then(res => {
                    commit('FETCH_DETAIL_TYPES', res.data.data);
                }).catch(err => {
                    return Promise.reject(err);
                })
        },
        fetchPostingAccounts({ commit }, params) {

            axios.get('/api/v1/accounts/getPostingAccounts', { params: params })
                .then(res => {
                    const data = res?.data?.data??[];
                    commit('FETCH_ALL_POSTING_ACCOUNTS', data);
            
                }).catch(err => {
                    return Promise.reject(err);
                })
        },
  

        fetchGroupingAccounts({ commit }, params) {

            axios.get('/api/v1/accounts/getGroupingAccounts', { params: params })
                .then(res => {
                    commit('FETCH_GROUPING_ACCOUNTS', res.data.data ? res.data.data : []);
                }).catch(err => {
                    return Promise.reject(err);
                })
        },

    },

}
